import React from 'react';

import { GIButton } from 'app-components';

// props

export interface SearchAgainProps {
    onClickHandler?: (boolean) => void;
}

function SearchAgain(props: SearchAgainProps) {

    const { onClickHandler } = props;

    return (
        <GIButton id='search_again_btn' labelId='ga.search_again' onClickHandler={() => onClickHandler && onClickHandler(true)} />
    );
}
export default SearchAgain;